const exclusiveBenefitsCloseSVG = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 14 14'
		fill='none'>
		<path
			d='M7.01862 5.78868L1.70117 0.5L0.500458 1.69422L5.81791 6.9829L7.01862 5.78868Z'
			fill='var(--neutral300)'
		/>
		<path
			d='M8.18304 6.98558L13.5005 1.6969L12.2998 0.50268L6.98233 5.79136L8.18304 6.98558Z'
			fill='var(--neutral300)'
		/>
		<path
			d='M7.01862 8.21132L1.70117 13.5L0.500458 12.3058L5.81791 7.0171L7.01862 8.21132Z'
			fill='var(--neutral300)'
		/>
		<path
			d='M8.18304 7.01442L13.5005 12.3031L12.2998 13.4973L6.98233 8.20864L8.18304 7.01442Z'
			fill='var(--neutral300)'
		/>
	</svg>
);

export { exclusiveBenefitsCloseSVG };
